import { Stack, Typography, Box, Switch, Button } from "@mui/material";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { useState } from "react";
import SaveChangesThirdST from "./SaveChangesThirdST";

// --- rows (your JSON data) ---
const rows = [
  {
    id: 1,
    searchTerm: "UK sports betting",
    matchType: "Broad",
    keywordname: "UK sports",
    KeywordMatchType: "Exact",
    AdgroupName: "UK - Football Betting | Tier 2 | Exact*",
    campaignName: "Sport | UK | EN | Tier 5 Offers | TCPA | FTD",
    lastSeen: "21/07/25",
    imp: "213,456",
    Clicks: "12,000",
    Cost: "1,999",
    CVR: "100.00",
    OtherKeywords: "2",
  },
  {
    id: 2,
    searchTerm: "best betting uk",
    matchType: "Broad",
    keywordname: "best betting uk",
    KeywordMatchType: "Broad",
    AdgroupName: "UK - Football Betting | Tier 2 | Exact*",
    campaignName: "Sport | UK | EN | Tier 5 Offers | TCPA | FTD",
    lastSeen: "01/07/25",
    imp: "12,000",
    Clicks: "1,200",
    Cost: "899",
    CVR: "85.50",
    OtherKeywords: "3",
  },
  {
    id: 3,
    searchTerm: "sport gambling",
    matchType: "Broad",
    keywordname: "gambling",
    KeywordMatchType: "Exact",
    AdgroupName: "UK - Betting Sites | Tier 3 |",
    campaignName: "Sport | IE | EN | Comparison 1 | TCPA | FTD",
    lastSeen: "08/07/25",
    imp: "300",
    Clicks: "90",
    Cost: "120",
    CVR: "70.00",
    OtherKeywords: "5",
  },
  {
    id: 4,
    searchTerm: "betting",
    matchType: "Exact",
    keywordname: "betting sites uk",
    KeywordMatchType: "Broad",
    AdgroupName: "UK - Football Betting | Tier 2 | Exact*",
    campaignName: "Sport | UK | EN | Tier 5 Offers | TCPA | FTD",
    lastSeen: "13/07/25",
    imp: "7,800",
    Clicks: "1,050",
    Cost: "650",
    CVR: "76.30",
    OtherKeywords: "245",
  },
  {
    id: 5,
    searchTerm: "online betting sites",
    matchType: "Broad",
    keywordname: "online betting",
    KeywordMatchType: "Exact",
    AdgroupName: "UK - Betting Sites | Tier 3 |",
    campaignName: "Sport | IE | EN | Comparison 1 | TCPA | FTD",
    lastSeen: "17/07/25",
    imp: "10,400",
    Clicks: "2,000",
    Cost: "1,250",
    CVR: "95.00",
    OtherKeywords: "124",
  },
];

const ThirdTableST = () => {
  const [openDialog, setOpenDialog] = useState(false);

  const handleOpen = () => setOpenDialog(true);
  const handleClose = () => setOpenDialog(false);
  // --- Define columns ---
  const columns: GridColDef[] = [
    { field: "searchTerm", headerName: "Search Term", flex: 1, minWidth: 160 },
    { field: "matchType", headerName: "Match Type", flex: 0.6, minWidth: 110 },
    {
      field: "keywordname",
      headerName: "Keyword Name",
      flex: 0.8,
      minWidth: 140,
    },
    {
      field: "KeywordMatchType",
      headerName: "Keyword Match Type",
      flex: 0.8,
      minWidth: 160,
    },
    {
      field: "AdgroupName",
      headerName: "Adgroup Name",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "campaignName",
      headerName: "Campaign Name",
      flex: 1,
      minWidth: 200,
    },
    { field: "lastSeen", headerName: "Last Seen", flex: 0.6, minWidth: 110 },
    { field: "imp", headerName: "IMP", flex: 0.6, minWidth: 110 },

    // 🔹 New fields
    { field: "Clicks", headerName: "Clicks", flex: 0.6, minWidth: 110 },
    { field: "Cost", headerName: "Cost", flex: 0.6, minWidth: 110 },
    { field: "CVR", headerName: "CVR (%)", flex: 0.6, minWidth: 110 },
    {
      field: "OtherKeywords",
      headerName: "Other Keywords",
      flex: 1,
      minWidth: 180,
    },

    {
      field: "Negative",
      headerName: "Negative",
      flex: 0.8,
      minWidth: 80,
      sortable: false,
      renderCell: () => <Switch defaultChecked color="success" />,
    },
  ];

  return (
    <>
      {/* Header with Bulk Actions */}
      <Stack
        mt={1}
        flexDirection={"row"}
        gap={1}
        justifyContent={"space-between"}
      >
        <Typography variant="h5">Filter to Display here</Typography>
        <Stack direction="row" alignItems="center" gap={1}>
          <Button variant="outlined" color="secondary" disabled>
            REMOVE NEGATIVE DEFINITION
          </Button>
        </Stack>
      </Stack>

      {/* DataGrid */}
      <Stack flexDirection={"column"} alignItems={"flex-end"} gap={2}>
        <Box sx={{ width: "100%", marginTop: 2, display: "grid" }}>
          <DataGridPro
            sx={{
              "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                outline: "none",
              },
              "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
                { outline: "none" },
              "& .MuiDataGrid-cellEmpty": {
                width: "auto",
                overflow: "hidden",
                textOverflow: "ellipsis",
              },

              // row selection only once
              "& .MuiDataGrid-row.Mui-selected": {
                backgroundColor: "rgba(156, 39, 176, 0.08) !important",
                "&:hover": {
                  backgroundColor: "rgba(156, 39, 176, 0.16) !important",
                },
              },

              "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedLeft": {
                backgroundColor: "#f0def3 !important",
              },
              "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedLeft":
                {
                  backgroundColor: "#e6d6e9ff !important",
                },

              // pinned RIGHT
              "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#f0def3 !important",
                },
              "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#e6d6e9ff !important",
                },
              // make pinned cells transparent → let row bg show through
              "& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#ffffff",
                },

              // remove extra blue tint on single cell select
              "& .MuiDataGrid-cell.Mui-selected": {
                backgroundColor: "inherit !important",
              },

              "& .MuiCheckbox-root": {
                color: "#9c27b0 !important",
              },
              "& .MuiCheckbox-root.Mui-checked": {
                color: "#9c27b0",
              },
              border: "none",
            }}
            density="compact"
            hideFooter
            //   disableMultipleRowSelection
            pagination={false}
            rows={rows}
            columns={columns}
            disableColumnMenu
            disableColumnFilter
            disableColumnReorder
            sortingOrder={["asc", "desc"]}
            isCellEditable={() => false}
            disableRowSelectionOnClick
            checkboxSelection
            initialState={{
              pinnedColumns: {
                left: ["__check__", "searchTerm", "matchType"],
                right: ["Negative"],
              },
            }}
          />
        </Box>
        <Button
          variant="contained"
          endIcon={<SaveOutlinedIcon />}
          color="secondary"
          onClick={handleOpen}
        >
          Save changes
        </Button>

        <SaveChangesThirdST open={openDialog} onClose={handleClose} />
      </Stack>
    </>
  );
};

export default ThirdTableST;
